import React, { useEffect, useState } from 'react';
import * as S from './estilos';

import useData from '../../Utils/useData/index';
import ReactHtmlParser from 'react-html-parser';
import Load from '../Load';

import ImgRiscoVermelho2 from '../../Images/ImgRiscoVermelho2.png';
import ImgRiscoVermelho2Resp from '../../Images/ImgRiscoVermelho2Resp.png';
import ImgCasa1 from '../../Images/saloes/1.jpg';
import ImgCasa2 from '../../Images/saloes/2.jpg';
import ImgCasa3 from '../../Images/saloes/3.jpg';

function Banner() {
  const [data, setData] = useState<any>([]);
  const [load, setLoad] = useState(false);

  const loadData = () => {
    setLoad(true);
    useData()
      .getData('/api/buffet.php')
      .then((response: any) => {
        setLoad(false);
        setData(response);
      })
      .catch((err) => {
        console.info(err);
      });
  };

  useEffect(() => {
    setTimeout(() => {
      loadData();
    }, 1000);
  }, []);

  return (
    <>
      {/* {load == true && <Load status={load} colorPrimary={'#c73127'} colorSecondary={'#b9b9b9'} />} */}
      <S.TextSaloes>Salões</S.TextSaloes>

      <>
        <div className='Ancora' id='Buffet'></div>
        <S.ForaBuffet key={'1'}>
          <S.ForaTextBuffetResp>
            <S.DentroForaTextBuffet>
              <S.TextBuffet1>
                <span>Praça do Cavalo</span>
              </S.TextBuffet1>
              {/* <S.TextBuffet1>próprio </S.TextBuffet1>
                  <S.TextBuffet1>e exclusivo</S.TextBuffet1> */}
            </S.DentroForaTextBuffet>
            <S.ImagemRiscoVermelho2 src={ImgRiscoVermelho2Resp} />
          </S.ForaTextBuffetResp>

          <S.ForaImagemBuffet>
            <S.ImagemBuffet src={ImgCasa1} />
          </S.ForaImagemBuffet>

          <S.DirBuffet>
            <S.ForaTextBuffet>
              <S.TextBuffet1>
                <span>Praça do Cavalo</span>
              </S.TextBuffet1>
              <S.ImagemRiscoVermelho2 src={ImgRiscoVermelho2} />
            </S.ForaTextBuffet>
            <S.TextBuffet2>
              {ReactHtmlParser(
                'A Praça Country ou Praça do Cavalo é o primeiro ambiente que você vê quando entra na casa. Com bar em forma de ferradura, expõe uma imensa estátua de montaria em bronze. Na lateral, um cenário típico do Western, com uma velha mina e uma cascata, completando a decoração.',
              )}
            </S.TextBuffet2>
          </S.DirBuffet>
        </S.ForaBuffet>
      </>

      <>
        <div className='Ancora' id='Buffet'></div>
        <S.ForaBuffet key={'1'}>
          <S.ForaTextBuffetResp>
            <S.DentroForaTextBuffet>
              <S.TextBuffet1>
                <span>Saloon</span>
              </S.TextBuffet1>
              {/* <S.TextBuffet1>próprio </S.TextBuffet1>
                  <S.TextBuffet1>e exclusivo</S.TextBuffet1> */}
            </S.DentroForaTextBuffet>
            <S.ImagemRiscoVermelho2 src={ImgRiscoVermelho2Resp} />
          </S.ForaTextBuffetResp>

          <S.ForaImagemBuffet>
            <S.ImagemBuffet src={ImgCasa2} />
          </S.ForaImagemBuffet>

          <S.DirBuffet>
            <S.ForaTextBuffet>
              <S.TextBuffet1>
                <span>Saloon</span>
              </S.TextBuffet1>
              <S.ImagemRiscoVermelho2 src={ImgRiscoVermelho2} />
            </S.ForaTextBuffet>
            <S.TextBuffet2>
              {ReactHtmlParser(
                'A Praça Country ou Praça do Cavalo é o primeiro ambiente que você vê quando entra na casa. Com bar em forma de ferradura, expõe uma imensa estátua de montaria em bronze. Na lateral, um cenário típico do Western, com uma velha mina e uma cascata, completando a decoração.',
              )}
            </S.TextBuffet2>
          </S.DirBuffet>
        </S.ForaBuffet>
      </>

      <>
        <div className='Ancora' id='Buffet'></div>
        <S.ForaBuffet key={'1'}>
          <S.ForaTextBuffetResp>
            <S.DentroForaTextBuffet>
              <S.TextBuffet1>
                <span>Praça Sertaneja</span>
              </S.TextBuffet1>
              {/* <S.TextBuffet1>próprio </S.TextBuffet1>
                  <S.TextBuffet1>e exclusivo</S.TextBuffet1> */}
            </S.DentroForaTextBuffet>
            <S.ImagemRiscoVermelho2 src={ImgRiscoVermelho2Resp} />
          </S.ForaTextBuffetResp>

          <S.ForaImagemBuffet>
            <S.ImagemBuffet src={ImgCasa3} />
          </S.ForaImagemBuffet>

          <S.DirBuffet>
            <S.ForaTextBuffet>
              <S.TextBuffet1>
                <span>Praça Sertaneja</span>
              </S.TextBuffet1>
              <S.ImagemRiscoVermelho2 src={ImgRiscoVermelho2} />
            </S.ForaTextBuffet>
            <S.TextBuffet2>
              {ReactHtmlParser(
                'A Praça Country ou Praça do Cavalo é o primeiro ambiente que você vê quando entra na casa. Com bar em forma de ferradura, expõe uma imensa estátua de montaria em bronze. Na lateral, um cenário típico do Western, com uma velha mina e uma cascata, completando a decoração.',
              )}
            </S.TextBuffet2>
          </S.DirBuffet>
        </S.ForaBuffet>
      </>
    </>
  );
}

export default Banner;
